import { createSelector } from 'reselect';
import { subselect } from './root';

const userDataSelector = (state, props, globalState) => globalState.userAccount.data || null;

const authenticatedUserIdSelector = createSelector([userDataSelector], (userData) => {
  let userId;
  if (userData) {
    userId = btoa(userData.email).replace(/[otulp\d\W]*/gi, '');
  }

  return userId;
});

export const triviaAuthenticatedUserIdSelector = subselect(authenticatedUserIdSelector);
